import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { ee } from '../shared/constants';
import { removeTooltipElement } from '../shared/functions';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  standalone: false
})
export class RegisterComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private router = inject(Router);
  toast = inject(ToastComponent);


  currentContent = 'register';
  menuItems = [
    { name: 'Register', link: 'register', icon: 'user-plus' },
  ];

  ngOnInit(): void {
    if (this.auth.loggedIn) {
      this.router.navigate(['/']);
      return;
    }
    ee.on('changeContent', (data: string) => this.currentContent = data);
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    removeTooltipElement();
  }

}
